export default {
    key: 'display',
    components: [
        {
            key: 'tableView',
            ignore: true
        },
        {
            key: 'hidden',
            ignore: true
        },
        {
            key: 'modalEdit',
            ignore: true
        },
        {
            key: 'refreshOnChange',
            ignore: true
        },
        {
            key: 'className',
            ignore: true,
        },
        {
            key: 'prefix',
            ignore: true
        },
        {
            key: 'suffix',
            ignore: true
        },
        {
            key: 'inputMask',
            ignore: true
        },
        {
            key: 'allowMultipleMasks',
            ignore: true
        },
        {
            key: 'showWordCount',
            ignore: true,
        },
        {
            key: 'showCharCount',
            ignore: true,
        },
        {
            key: 'labelPosition',
            ignore: true
        }
    ]
};
